module.exports = __webpack_public_path__ + "static/img/submit.6322980a.png";